// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1efTJ","disabled":"FileBtn_disabled__2vhR3","warn":"FileBtn_warn__3ZVQw","fade":"FileBtn_fade__zSUwE"};